import { Injectable } from '@angular/core'
import { ConditionsEnum, ISVariableValueEnum, OperatorsEnum } from './definitions.enum'
import { IGroupRule } from './group-rule.model'
import { IRule } from './rule.model'

@Injectable({
  providedIn: 'root',
})
export class QueryBuilderService {
  private _ruleVariables: { name: string; type: string }[] = []
  private _ruleOperators: string[] = [OperatorsEnum.Is, OperatorsEnum.Is_NOT]
  private _ruleValues: string[] = [ISVariableValueEnum.Active]

  public set ruleVariables(value: { name: string; type: string }[]) {
    this._ruleVariables = value
  }

  public get ruleVariables(): { name: string; type: string }[] {
    return this._ruleVariables
  }

  public get ruleOperators(): string[] {
    return this._ruleOperators
  }

  public get ruleValues(): string[] {
    return this._ruleValues
  }

  /** METHODS */

  public groupToString(group: IGroupRule): string | null {
    if (group.rules.length === 0) {
      return null
    }
    const conditions: string[] = []
    try {
      for (let i: number = 0; i < group.rules.length; i++) {
        const isRule: boolean = group.rules[i]['rules'] === undefined
        if (isRule) {
          const rule: IRule = group.rules[i] as IRule
          if (rule.field === null || rule.operator === null || rule.value === null) {
            throw Error('Empty rule.')
          }
          conditions.push(this.ruleToString(rule))
        } else {
          const groupCondition: string = this.groupToString(group.rules[i] as IGroupRule)
          if (groupCondition === null) {
            throw Error('Empty group rule.')
          }
          conditions.push(`(${groupCondition})`)
        }
      }
      return conditions.join(` ${group.condition} `)
    } catch (e) {
      return null
    }
  }

  public ruleToString(rule: IRule): string {
    if (rule.operator.trim() === OperatorsEnum.Is_NOT) {
      return `!${rule.field}`
    } else {
      return `${rule.field}`
    }
  }

  public stringToArray(str: string): any[] {
    let i: number = 0
    function main(): any[] {
      const arr: any[] = []
      let startIndex: number = i

      function addWord(): void {
        if (i - 1 > startIndex) {
          arr.push(str.slice(startIndex, i - 1))
        }
      }

      while (i <= str.length) {
        // Before was i < str.length ~ check in the future
        switch (str[i++]) {
          case ' ':
            addWord()
            startIndex = i
            continue
          case '(':
            arr.push(main())
            startIndex = i
            continue
          case ')':
            addWord()
            return arr
        }
      }
      addWord()
      return arr
    }
    return main()
  }

  public arrayToGroupRule(arr: any[]): IGroupRule {
    function stringAsRule(ruleAsString: string): IRule | null {
      const variableType: 'FE' | 'IS' = 'IS'
      switch (true) {
        case variableType === 'IS':
          if (ruleAsString.indexOf('!') === 0) {
            return {
              field: ruleAsString.substring(1, ruleAsString.length),
              operator: OperatorsEnum.Is_NOT,
              value: ISVariableValueEnum.Active,
            }
          } else {
            return {
              field: ruleAsString,
              operator: OperatorsEnum.Is,
              value: ISVariableValueEnum.Active,
            }
          }
        default:
          return null
      }
    }

    let tmp: any[] = []
    let condition: ConditionsEnum.AND | ConditionsEnum.OR = ConditionsEnum.AND
    const rules: (IRule | IGroupRule)[] = []

    for (let i: number = 0; i < arr.length; i++) {
      if (arr[i] instanceof Array) {
        rules.push(this.arrayToGroupRule(arr[i]))
      } else {
        if (
          arr[i].toUpperCase() !== ConditionsEnum.AND &&
          arr[i].toUpperCase() !== ConditionsEnum.OR
        ) {
          tmp.push(arr[i])
        }
        if (
          arr[i].toUpperCase() === ConditionsEnum.AND ||
          arr[i].toUpperCase() === ConditionsEnum.OR ||
          i === arr.length - 1
        ) {
          if (
            arr[i].toUpperCase() === ConditionsEnum.AND ||
            arr[i].toUpperCase() === ConditionsEnum.OR
          ) {
            condition = arr[i]
          }
          if (tmp.length > 0) {
            const rule: IRule = stringAsRule(tmp.join(' '))
            if (rule !== null) {
              rules.push(rule)
            }
          }
          tmp = []
        }
      }
    }

    return {
      condition: condition,
      rules: rules,
    }
  }
}
